module.exports = __webpack_public_path__ + "images/ai_recommendations/share-08ee184515434a0ec7fbd45ef530dbb3.svg";